import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
var UserTypeDataService = /** @class */ (function () {
    function UserTypeDataService() {
    }
    UserTypeDataService.prototype.setUserType = function (jwtToken) {
        OmapiIdsUtils.setUserTypeGlobally(jwtToken);
    };
    UserTypeDataService.prototype.setDarwinUserType = function (dwnType) {
        OmapiIdsUtils.setDarwinUserTypeGlobally(dwnType);
    };
    return UserTypeDataService;
}());
export { UserTypeDataService };
